import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loan-header',
  templateUrl: './loan-header.component.html',
  styleUrl: './loan-header.component.scss',
  standalone: false
})
export class LoanHeaderComponent {
  @Input({ required: true }) headerText: string = '';
  @Input({ required: true }) subHeaderText: string = '';
}
